import { IGrouping, IOption } from "../../interfaces/form-builder/i-element";
import { IInput, IScoreTableInput, IListInput, IOptionsInput } from "../../interfaces/form-builder/i-input";

export function setElementPillColor(
    element: IInput | IScoreTableInput | IListInput | IOptionsInput | IOption | IGrouping
) {
    if (element.codeColor) {
        let classNameReplacement = element.name;
        if (element.name.includes(".")) {
            classNameReplacement = element.name.replace(/\./g, "_");
        }
        const style = document.createElement("style");
        style.innerHTML = `
              .pill-color-${classNameReplacement} {
                background-color: ${element.codeColor} !important;
              }
            `;
        document.head.appendChild(style);
        return `pill-color-${classNameReplacement}`;
    }
    return "";
}

export function cleanElementCode(
    element: IInput | IScoreTableInput | IListInput | IOptionsInput | IOption | IGrouping
) {
    if (element.code.includes("_")) {
        return element.code.split("_")[0];
    } else {
        return element.code;
    }
}
